export const DELETE_EMPLOYEE_SHIFT = 'DELETE_EMPLOYEE_SHIFT'
export const DELETE_EMPLOYEE_SHIFT_PENDING = 'DELETE_EMPLOYEE_SHIFT_PENDING'
export const DELETE_EMPLOYEE_SHIFT_FULFILLED = 'DELETE_EMPLOYEE_SHIFT_FULFILLED'
export const DELETE_EMPLOYEE_SHIFT_REJECTED = 'DELETE_EMPLOYEE_SHIFT_REJECTED'

export const CLEAR_SCHEDULERS = 'CLEAR_SCHEDULERS'
export const CLEAR_SCHEDULERS_PENDING = 'CLEAR_SCHEDULERS_PENDING'
export const CLEAR_SCHEDULERS_FULFILLED = 'CLEAR_SCHEDULERS_FULFILLED'
export const CLEAR_SCHEDULERS_REJECTED = 'CLEAR_SCHEDULERS_REJECTED'
